import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';

export const FETCH_SPIN_WRITING_ASSIGNMENT_REQUEST = 'FETCH_SPIN_WRITING_ASSIGNMENT_REQUEST';
export const FETCH_SPIN_WRITING_ASSIGNMENT_SUCCESS = 'FETCH_SPIN_WRITING_ASSIGNMENT_SUCCESS';
export const FETCH_SPIN_WRITING_ASSIGNMENT_FAILURE = 'FETCH_SPIN_WRITING_ASSIGNMENT_FAILURE';

const buildSPINWrittingAssignmentURL = (groupId) => buildUrl(`/groups/${groupId}/spin-writing-assignments`);

export function fetchSPINWrittingAssignmentIfNeed(groupId) {
  const method = 'GET';
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method, url: buildSPINWrittingAssignmentURL(groupId) })) {
      return false;
    }

    return dispatch(fetchSPINWrittingAssignment(groupId));
  };
}

export function fetchSPINWrittingAssignment(groupId) {
  return (dispatch) => {
    const url = buildSPINWrittingAssignmentURL(groupId);
    const method = 'GET';

    return dispatch(fetchSPINWrittingAssignmentRequest()).payload
      .then((response) => dispatch(fetchSPINWrittingAssignmentSuccess(response)))
      .catch((error) => dispatch(fetchSPINWrittingAssignmentFailure(error)));

    function fetchSPINWrittingAssignmentRequest() {
      return ApiCall.createAction({
        type: FETCH_SPIN_WRITING_ASSIGNMENT_REQUEST,
        payload: fetch(url),
        url,
        method,
      });
    }

    function fetchSPINWrittingAssignmentSuccess(response) {
      return ApiCall.createAction({
        type: FETCH_SPIN_WRITING_ASSIGNMENT_SUCCESS,
        payload: response,
        url,
        method,
        groupId,
      });
    }

    function fetchSPINWrittingAssignmentFailure(error) {
      return ApiCall.createAction({
        type: FETCH_SPIN_WRITING_ASSIGNMENT_FAILURE,
        error,
        url,
        method,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/WritingAssignment/SPIN/actions.js